module.exports = __webpack_public_path__ + "static/media/rotate-icon.b44e018a.svg";